import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetIsPricePointSetFromCookie } from 'store/actions';
import {
	checkoutBeginsSelector,
	chosenDurationSelector,
	chosenKilometrageSelector,
} from 'store/selectors';
import { getValueFromCookie } from 'utils';

export const useResetPricePoint = () => {
	const dispatch = useDispatch();
	const checkoutBegins = useSelector(checkoutBeginsSelector);
	const selectedDuration = useSelector(chosenDurationSelector);
	const selectedKilometrage = useSelector(chosenKilometrageSelector);

	const durationValueFromCookie = getValueFromCookie('duration');
	const kmValueFromCookie = getValueFromCookie('kilometrage');

	useEffect(() => {
		if (
			!checkoutBegins ||
			selectedDuration !== durationValueFromCookie ||
			selectedKilometrage !== kmValueFromCookie
		) {
			dispatch(resetIsPricePointSetFromCookie());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
